const sites = {
  id: "sites",
  label: "Sites",
  endpoint: "sites",
  columnConfig: [
    {
      field: "name",
      headerName: "Name",
      width: 200,
      description: "Name",
      editable: true,
    },
    {
      field: "site_number",
      headerName: "Site Number",
      width: 175,
      description: "Site Number",
      editable: true,
      renderCell: (params) => {
        const site_number = params.row.site_number;
        return `${site_number}`
      }
    },
    {
      field: "station_name",
      headerName: "Station Name",
      width: 250,
      description: "Station Name",
      editable: true,
    },
    {
      field: "site_type",
      headerName: "Site Type",
      width: 185,
      description: "Site Type",
      editable: true,
      renderCell: (params) => {
        const type = params.row.site_type;
        // Return a custom component or a simple string that combines the name and id
        return type?.name || "";
      },
      valueFormatter: (params) => {
        const type = params.value;
        return type?.name || "";
      },
      renderEditCellProps: {
        categoriesEndpoint: "site_types",
        categoriesEndpointResponseKey: "site_types",
        categoriesEndpointResponseOptionsKey: "name",
        entityToUpdate: "sites",
        entityColumnToUpdate: "site_type_id",
      },
    },
    {
      field: "site_status",
      headerName: "Site Status",
      width: 185,
      description: "Site Status",
      editable: true,
      renderCell: (params) => {
        const type = params.row.site_status;
        // Return a custom component or a simple string that combines the name and id
        return type?.name || "";
      },
      valueFormatter: (params) => {
        const type = params.value;
        return type?.name || "";
      },
      renderEditCellProps: {
        categoriesEndpoint: "site_statuses",
        categoriesEndpointResponseKey: "site_statuses",
        categoriesEndpointResponseOptionsKey: "name",
        entityToUpdate: "sites",
        entityColumnToUpdate: "site_status_id",
      },
    },
    {
      field: "existing_parameters",
      headerName: "Existing Parameters",
      width: 185,
      description: "Existing parameters",
      editable: true,
      renderCell: (params) => {
        const parameters = params.row.existing_parameters;
        return parameters?.map((p) => p?.name).join(", ") || "";
      },
      valueFormatter: (params) => {
        const parameters = params.value;
        return parameters?.map((p) => p?.name).join(", ") || "";
      },
      renderEditCellComponent: "SelectSiteParameters",
    },
    {
      field: "ngwos_parameters",
      headerName: "NGWOS Added Parameters",
      width: 185,
      description: "NGWOS added parameters",
      editable: true,
      renderCell: (params) => {
        const parameters = params.row.ngwos_parameters;
        return parameters?.map((p) => p?.name).join(", ") || "";
      },
      valueFormatter: (params) => {
        const parameters = params.value;
        return parameters?.map((p) => p?.name).join(", ") || "";
      },
      renderEditCellComponent: "SelectSiteParameters",
    },
    {
      field: "projects",
      headerName: "Projects",
      width: 200,
      description: "Projects",
      editable: false,
      renderCell: (params) => {
        const projects = params.row.projects;
        return projects?.map((p) => p?.name).join(", ") || "";
      },
      valueFormatter: (params) => {
        const projects = params.value;
        return projects?.map((p) => p?.name).join(", ") || "";
      },
    },
    {
      field: "datum",
      headerName: "Datum",
      width: 185,
      description: "Datum",
      editable: true,
      renderCell: (params) => {
        const type = params.row.datum;
        // Return a custom component or a simple string that combines the name and id
        return type?.name || "";
      },
      valueFormatter: (params) => {
        const type = params.value;
        return type?.name || "";
      },
      renderEditCellProps: {
        categoriesEndpoint: "datums",
        categoriesEndpointResponseKey: "datums",
        categoriesEndpointResponseOptionsKey: "name",
        entityToUpdate: "sites",
        entityColumnToUpdate: "datum_id",
      },
    },
    {
      field: "nwis_site_url",
      headerName: "NWIS Site Link (New)",
      width: 200,
      description: "NWIS Site Link (New)",
      editable: true,
    },
    {
      field: "latitude",
      headerName: "Latitude",
      width: 200,
      description: "Latitude",
      editable: true,
    },
    {
      field: "longitude",
      headerName: "Longitude",
      width: 200,
      description: "Longitude",
      editable: true,
    },
    {
      field: "installation_date",
      headerName: "Installation Date",
      width: 200,
      description: "Installation Date",
      editable: true,
    },
    {
      field: "months_of_operation",
      headerName: "Months of Operation",
      width: 200,
      description: "Months of Operation",
      editable: true,
    },
    {
      field: "notes",
      headerName: "Notes",
      width: 200,
      description: "Notes",
      editable: true,
    },
  ],
  // these columns are present in the data but **shouldn't** be displayed in the UI
  hiddenColumns: [
    "id",
    "pi_datacheck",
    "pi_datacheck_date",
    "name",
    "datum_id",
    "site_status_id",
    "site_type_id",
  ],
  chipConfig: {},
  tagConfig: {},
};

export default sites;
